import { useTranslation } from 'react-i18next'

import { Divider, Text } from '@reveni-io/reveni-ui'

import { integrationsCategories } from '../constants'
import Integration from '../Integration/Integration'
import * as Styles from './styles'

const IntegrationsAvailable = ({ integrations, handleEditIntegration }) => {
  const { t } = useTranslation()

  const getIntegrationsByCategory = category => {
    return integrations.filter(integration => integration.category === category.type)
  }

  if (!integrations || integrations.length === 0) return null

  return (
    <>
      <Divider />
      <Text type="titleS">{t('Disponibles')}</Text>
      <Text type="bodyMRegular">{t('Selecciona la integración que quieres conectar')}</Text>
      {integrationsCategories.map(
        category =>
          getIntegrationsByCategory(category).length > 0 && (
            <div key={category.category}>
              <Styles.CategoryTitle>
                {category.icon}
                <Text type="bodyMBold">{t(category.name)}</Text>
              </Styles.CategoryTitle>
              <Styles.IntegrationsContainer>
                {getIntegrationsByCategory(category).map(integration => (
                  <Integration key={integration.type} integration={integration} onEdit={handleEditIntegration} />
                ))}
              </Styles.IntegrationsContainer>
            </div>
          )
      )}
    </>
  )
}

export default IntegrationsAvailable
